import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0212256"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleMenu" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Minha conta ")
], -1))
const _hoisted_2 = { class: "avatarUser" }
const _hoisted_3 = {
  key: 0,
  class: "emailBtnContainer"
}
const _hoisted_4 = { class: "emailUser" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "E-mail:", -1))
const _hoisted_6 = { class: "email" }
const _hoisted_7 = {
  key: 0,
  class: "pt-8",
  style: {"font-weight":"bold","margin-top":"30px"}
}
const _hoisted_8 = {
  key: 0,
  class: "sucessoSalvar"
}
const _hoisted_9 = {
  key: 0,
  class: "trocarSenhaform"
}
const _hoisted_10 = {
  key: 0,
  class: "errorSenhasDiferentes"
}
const _hoisted_11 = { class: "btnContainer" }
const _hoisted_12 = {
  key: 0,
  class: "erroSalvar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_ctx.$store.state.menuDesktop)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "overlay",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeMenu()))
      }, [
        _createVNode(_Transition, { name: "showmenuuser" }, {
          default: _withCtx(() => [
            (_ctx.showMenu)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                  class: "menuDesktop"
                }, [
                  _hoisted_1,
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.initials || ""), 1)
                  ]),
                  _createVNode(_Transition, { name: "trocarsenhatransition" }, {
                    default: _withCtx(() => [
                      (!_ctx.trocarSenha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _hoisted_5,
                              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user?.email || ""), 1)
                            ]),
                            _createVNode(_component_v_btn, {
                              class: "trocarSenha",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trocarSenha = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Trocar senha ")
                              ]),
                              _: 1
                            }),
                            (_ctx.user.tipo == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Relatório de usuários: "))
                              : _createCommentVNode("", true),
                            (_ctx.user.tipo == 1)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 1,
                                  class: "download_btn",
                                  onClick: _ctx.downloadRelatorioUsuario
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Download ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_Transition, { name: "fade" }, {
                              default: _withCtx(() => [
                                (_ctx.sucessoSalvar)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Senha alterada com sucesso! "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "trocarsenhatransition" }, {
                    default: _withCtx(() => [
                      (_ctx.trocarSenha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.senhaAtual,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.senhaAtual) = $event)),
                              label: "Senha Atual",
                              "append-inner-icon": _ctx.hideSenhaAtual ? 'mdi-eye' : 'mdi-eye-off',
                              "onClick:appendInner": _cache[2] || (_cache[2] = () => (_ctx.hideSenhaAtual = !_ctx.hideSenhaAtual)),
                              type: _ctx.hideSenhaAtual ? 'password' : 'text',
                              rules: _ctx.passOldRule
                            }, null, 8, ["modelValue", "append-inner-icon", "type", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.novaSenha,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.novaSenha) = $event)),
                              label: "Nova Senha",
                              "append-inner-icon": _ctx.hideNovaSenha ? 'mdi-eye' : 'mdi-eye-off',
                              "onClick:appendInner": _cache[4] || (_cache[4] = () => (_ctx.hideNovaSenha = !_ctx.hideNovaSenha)),
                              type: _ctx.hideNovaSenha ? 'password' : 'text',
                              rules: _ctx.passwordRules
                            }, null, 8, ["modelValue", "append-inner-icon", "type", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.confirmarNovaSenha,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmarNovaSenha) = $event)),
                              label: "Confirmar nova senha",
                              "append-inner-icon": 
                _ctx.hideConfirmarSenha ? 'mdi-eye' : 'mdi-eye-off'
              ,
                              "onClick:appendInner": _cache[6] || (_cache[6] = 
                () => (_ctx.hideConfirmarSenha = !_ctx.hideConfirmarSenha)
              ),
                              type: _ctx.hideConfirmarSenha ? 'password' : 'text',
                              "hide-details": ""
                            }, null, 8, ["modelValue", "append-inner-icon", "type"]),
                            (_ctx.errorSenhasDiferentes)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " As senhas não correspondem! "))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_v_btn, {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trocarSenha = false)),
                                class: "btnCancelar"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Cancelar ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                class: "btnSalvar",
                                onClick: _ctx.salvarSenha,
                                loading: _ctx.salvarSenhaLoading,
                                disabled: 
                  _ctx.errorSenhasDiferentes || _ctx.faltaCampo || _ctx.erroRegraSenha
                
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Salvar ")
                                ]),
                                _: 1
                              }, 8, ["onClick", "loading", "disabled"])
                            ]),
                            _createVNode(_Transition, { name: "fade" }, {
                              default: _withCtx(() => [
                                (_ctx.erroSalvar)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Ocorreu um erro ao salvar a senha. Verifique se a senha atual está correta e tente novamente. "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}